import { Box } from '@mui/material';
import PrimarySearchAppBar from '../components/PrimarySearchAppBar';
import GetResult from '../components/GetResult';

export const ResultSearchPage = () => (
	<Box
		display='flex'
		flexDirection='column'
		width='100vw'
		height='100vh'
	>
		<PrimarySearchAppBar/>
		<GetResult/>
	</Box>
);
